module.exports = __webpack_public_path__ + "static/media/BANANA.06309c43.svg";